<template lang="pug">
  #CustomerTempModel.CustomerModel.CustomerModel-tempModel.overflow-hidden(
    :class="{ 'CustomerModel-active': showModel }"
  )
    .content-header.modal_header.rounded-bottom-1rem.pt-0(
      style="height: 50px;"
    )
      .row.align-items-center.h-100
        .col-10
          h5.mb-0 {{ title }}
        .col-2.d-flex.align-items-center.justify-content-center
          i.iconClose(
            @click="closeModel()"
          )
    .h-100.overflow-hidden(
      style="padding-top: 60px!important;"
    )
      .content.h-100.overflow-auto(
        style="padding-bottom: 70px;"
      )
        .search-area.row.mx-0.px-3
          //- .col.px-0.d-flex.align-items-center.pr-2
          //-   el-cascader.w-100(
          //-     v-model='searchCategory',
          //-     :options='categories',
          //-     clearable,
          //-     :props='{ value: "id", label: "title", children: "subCategory" }',
          //-     :show-all-levels="false",
          //-     placeholder="商品類別",
          //-   )
          .col.px-0.d-flex.align-items-center
            el-input.w-100(
              v-model='searchName',
              clearable,
              placeholder="商品名稱"
            )
          .col-auto.pl-2.pr-0
            button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
              type="button",
              @click="searchHandler",
              style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
              ) 搜尋
        .mb-2.mx-3.p-3
          template(
            v-for="(product, index) in products"
          )
            .row.product.mb-3.px-3.py-2.outline-product.border-black.custom-shadow
              .content-product
                .input_wrap.d-flex
                  .product_info.row.w-100.h-100
                    .col
                      h6.mb-1 {{ product.name }}
                    .col-auto.px-2.d-flex.align-itwems-center
                      button.btn.btn-block.btn-remind.font-weight-bold.btn-custom.px-3(
                        type="button",
                        @click="productsPush(product.id, product.group_id, product.name)",
                        style="border: 0.4rem solid #fff;border-radius: 50px;padding: 5px;border: 4px solid #000;box-shadow: 0.2rem 0.2rem 0 #00000033;"
                        ) 發送

          infinite-loading(
            @infinite="infiniteHandler",
            :identifier="infiniteId",
            spinner="bubbles",
            ref="infiniteLoading"
          )
            .cursor-default.mt-3(slot="no-more") 無更多商品
            .cursor-default.mt-3(slot="no-results") 無更多商品
            .cursor-default.mt-3(slot="error") 發生錯誤，請重整重試一次

</template>

<script>
import { mapState } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import IconCloseUrl from '@/assets/images/icon/icon_close.png';
import $ from 'jquery';
import tempTextModel from '@/components/customerModel/tempTextModel.vue';
import tempSendPreviewModel from '@/components/customerModel/tempSendPreviewModel.vue';
import UdRatio from '@/components/udon-ui/UdRatio.vue';

// 模板顯示部分
import textInput from '@/components/modalTemplate/messageText/textInput.vue';
import imageMapInput from '@/components/modalTemplate/messageImageMap/imageMapInput.vue';
import carouselInput from '@/components/modalTemplate/messageCarousel/carouselInput.vue';

const _ = require('lodash');

export default {
  name: 'ProductBuyModel',
  components: {
    InfiniteLoading,
    tempTextModel,
    tempSendPreviewModel,
    textInput,
    imageMapInput,
    carouselInput,
    UdRatio
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: null
    },
    multicastPush: {
      type: Boolean,
      default: false
    },
    users: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      iconUrl: {
        IconClose: IconCloseUrl
      },
      showModel: false,
      tempModelCSS: {
        top: 0
      }, // 新增訊息模板的 CSS
      infiniteId: +new Date(),
      windowScrollHeight: 0, // 視窗原本位置
      searchCategory: [],
      searchName: "",
    };
  },
  mounted() {
    this.$EventBus.$on('openProductBuyModel', () => {
      this.initHandler();
    });
  },
  methods: {
    initHandler() {
      const vm = this;
      vm.$swal.fire({
        title: '載入中，請稍候',
        allowOutsideClick: false,
        willOpen: () => {
          this.$swal.showLoading();
        }
      });
      // 初始化
      // vm.$store.dispatch('sa_product_buy/getCategoryHandler');
      vm.$store.commit('sa_product_buy/resetInfiniteLoadingData');

      vm.$swal.close();
      vm.openModel();
      vm.infiniteId += 1;
    },
    infiniteHandler($state) {
      const vm = this;
      if (!vm.showModel) return;

      let category = '';
      if(vm.searchCategory) {
        category = vm.searchCategory.length >= 1 ? vm.searchCategory[vm.searchCategory.length - 1] : '';
      }
      vm.$store.dispatch('sa_product_buy/getProductsHandler', {
        current_page: vm.pagination.current_page + 1,
        per_page: vm.pagination.per_page,
        category: category,
        name: vm.searchName
      }).then(() => {
        if (vm.pagination.current_page !== vm.pagination.total_page) {
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    searchHandler() {
      this.$store.commit('sa_product_buy/resetInfiniteLoadingData');
      this.infiniteId += 1;
    },
    openModel() {
      this.showModel = true;
    },
    closeModel() {
      this.searchCategory = [];
      this.searchName = "";
      this.$emit('closeModelHandler');
      this.showModel = false;
      $('.icon-back').removeClass('d-none');
    },
    // 發送商品
    async productsPush(id, groupId, name) {
      const vm = this;
      vm.$swal.fire({
          title: '確認發送',
          html: `是否要發送<b>${name}</b>?`, // html
          icon: 'warning', // success、error
          confirmButtonText: '確定',
          showCancelButton: true,
          cancelButtonText: '取消',
          reverseButtons: true,
      }).then(result => {
        if(result.isConfirmed) {

          vm.$swal.fire({
            title: '商品發送中，請稍候',
            allowOutsideClick: false,
            willOpen: () => {
              vm.$swal.showLoading();
            }
          });

          if (vm.multicastPush) {
            const sendData = {
              member_uuid: _.map(vm.users, (val) => val.member_line_uuid || val.line_uuid),
              product_id: id,
              product_group_id: groupId
            };
            vm.$store.dispatch('sa_chat/productsBuyMulticastPushHandler', sendData)
              .then(() => {
                vm.$emit('closeModelHandler');
                vm.closeModel();
                vm.$swal.close();
              });
          } else {
            const sendData = {
              member_uuid: vm.user.member_uuid || vm.user.member_line_uuid,
              product_id: id,
              product_group_id: groupId
            };

            vm.$store.dispatch('sa_chat/productsBuyPushHandler', sendData)
              .then(() => {
                vm.$emit('closeModelHandler');
                vm.closeModel();
                vm.$swal.close();
              });
            }

        }
      });
    },
    // 把視窗移到最頂部
    scrollToTop() {
      return new Promise((resolve, reject) => {
        if ($('#CustomerTempModel').scrollTop() === 0) {
          resolve();
        } else {
          $('#CustomerTempModel').animate({
            scrollTop: 0
          }, 500);
        }
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').addClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
    // 把視窗移到原本位置
    scrollToTarget() {
      const vm = this;
      return new Promise((resolve, reject) => {
        $('#CustomerTempModel').animate({
          scrollTop: vm.windowScrollHeight
        }, 500);
        setTimeout(() => {
          // 鎖定上下滑動 防止爆版
          $('#CustomerTempModel').removeClass('overflow-hidden');
          resolve();
        }, 550);
      });
    },
  },
  beforeDestroy() {
    this.$EventBus.$off('openProductBuyModel');
  },
  computed: {
    ...mapState({
      categories: (state) => state.sa_product_buy.categories,
      products: (state) => state.sa_product_buy.products,
      pagination: (state) => state.sa_product_buy.pagination
    }),
  },
  watch: {
    searchCategory() {
      if(this.searchCategory) {
        if(this.searchCategory.length === 0) this.searchCategory = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>

  @font-face {
    font-family: "icon";
    src: url("../../assets/fonts/icon.eot?hrpp7d");
    src: url("../../assets/fonts/icon.eot?hrpp7d#iefix") format("embedded-opentype"), url("../../assets/fonts/icon.ttf?hrpp7d") format("truetype"), url("../../assets/fonts/icon.woff?hrpp7d") format("woff"), url("../../assets/fonts/icon.svg?hrpp7d#icon") format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }

  i {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "icon" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 1.2rem;
    margin-bottom: 4px;
  }

  .iconClose:before {
    content: "\e908";
  }

  .border-black{
    border: 0.2rem solid #000;
  }
  .outline-product {
    display: block;
    border-radius: 1rem;
    padding: 1rem;
    cursor: pointer;
  }
  .custom-shadow {
    -webkit-box-shadow: 0.2rem 0.2rem 0 #00000033;
    box-shadow: 0.2rem 0.2rem 0 #00000033;
  }

  .custom-check-icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 0.4rem;
    margin-right: 1.2rem;
    position: relative;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon {
    background-color: #ef4852;
  }

  .custom_checker:checked ~ .input_wrap .custom-check-icon::after {
    display: block;
  }

  .custom-check-icon::after {
    content: '';
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1rem;
    background-image: url(../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  .product_info {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 100px;
  }
  .product_info > .col {
    display: flex;
    align-items: center;
  }

  input[type="checkbox"], input[type="radio"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }
</style>

<style lang="scss">
  .el-radio {
    padding-top: 8px;
  }
  .el-cascader-menu {
    min-width: 40vw;
    max-width: 160px;
  }
  .el-cascader-node {
    padding-left: 10px;
  }
  .el-input__inner {
    border-radius: 20px;
    background-color: #eee;
  }
  .el-cascader-node__label {
    padding: 0;
  }
  .el-icon-circle-close {
    color: #333;
  }
  /*Fixes double tap on iOS*/
  .el-scrollbar {
    > .el-scrollbar__bar {
      opacity: 1 !important;
    }
  }
</style>
